import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  root: {
    display: 'flex',
    gap: '20px',
    flexDirection: 'column',
  },
  flexbox: {
    display: 'flex',
  },
  addSpacing: {
    display: 'flex',
    gap: '20px',
  },
  horizontalCentered: {
    alignItems: 'center',
  },
  verticalLine: {
    height: '60px',
    width: 1,
    backgroundColor: '#909090',
  },
  inputError: {
    border: '0.5px solid red',
  },
  input: {
    height: '40px',
    borderRadius: '4px',
    fontFamily: 'Inter, sans-serif',
    fontSize: '14px',
    width: '100%',
    marginTop: '6px',
    backgroundColor: 'white',
  },
  errorMessage: {
    color: 'red',
    marginTop: '13px',
  },
  connectButton: {
    backgroundColor: '#94BE46',
    marginTop: '53px',
  },
  text: {
    fontSize: '24px',
    fontWeight: '700',
  },
  successText: {
    fontSize: '24px',
    fontWeight: '700',
    lineHeight: '34px',
  },
  form: {
    display: 'flex',
    gap: '20px',
    width: '500px',
    flexDirection: 'column',
    background: '#fff',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
  },
  link: {
    color: 'black',
    fontWeight: 'bold',
  },
}));
